<div
    class="vds-checkbox-form-field"
    [class.vds-checkbox-form-field--align-end]="labelPosition() === 'before'"
    (click)="_preventBubblingFromLabel($event)"
>
    <div class="vds-checkbox__container">
        <div class="vds-checkbox-touch-target" (click)="_onTouchTargetClick()"></div>
        <input
            #input
            type="checkbox"
            class="vds-checkbox__native-control"
            [class.vds-checkbox--selected]="checked()"
            [attr.aria-label]="ariaLabel() || null"
            [attr.aria-labelledby]="ariaLabelledBy()"
            [attr.aria-describedby]="ariaDescribedBy()"
            [attr.aria-checked]="indeterminate() ? 'mixed' : null"
            [attr.name]="name()"
            [attr.value]="value()"
            [checked]="checked()"
            [indeterminate]="indeterminate()"
            [disabled]="disabled"
            [id]="inputId()"
            [required]="required()"
            [tabIndex]="tabIndex()"
            (blur)="_onBlur()"
            (click)="_onInputClick()"
            (change)="_onInteractionEvent($event)"
        />
        <div class="vds-checkbox__background">
            <svg focusable="false" viewBox="0 0 18 18" aria-hidden="true" class="vds-checkbox__checkmark">
                <path
                    fill="none"
                    d="M4.33414 9.10521L7.59485 12.3007L13.6656 6.35071"
                    stroke-linecap="square"
                    class="vds-checkbox__checkmark-path"
                />
            </svg>
            <div class="vds-checkbox__mixedmark"></div>
        </div>
    </div>
    <label class="c-checkbox__label" [for]="inputId()" #label>
        <ng-content></ng-content>
    </label>
</div>
